import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { FC, useEffect, useState } from 'react';
import { FiCopy } from 'react-icons/fi';
import { TbTrash } from 'react-icons/tb';
import { showMessage } from 'shared/api';
import { cn } from 'shared/lib';

interface IProps {
  onDelete?: () => void;
  value?: string;
  className?: string;
  inputClassName?: string;
  copyClassName?: string;
  readOnly?: boolean;
  onTextChange?: (text: string) => void;
}
export const ApiKeyInput: FC<IProps> = ({
  value = '',
  className = '',
  inputClassName = '',
  copyClassName = '',
  readOnly = false,
  onDelete
}) => {
  const [showApiKey, setShowApiKey] = useState(false);
  const [state, setState] = useState(value);

  useEffect(() => {
    setState(value);
  }, [value]);

  return (
    <div
      className={cn(
        'yep_ex-flex yep_ex-gap-2 yep_ex-items-center yep_ex-pr-4',
        className
      )}
    >
      <div className="yep_ex-relative yep_ex-rounded-md yep_ex-shadow-sm yep_ex-w-full">
        <input
          type={showApiKey ? 'text' : 'password'}
          className={cn(
            'yep_ex-w-full yep_ex-text-neutral-500 yep_ex-border yep_ex-block yep_ex-rounded-md yep_ex-py-2 yep_ex-pl-3 yep_ex-pr-10',
            inputClassName
          )}
          readOnly={readOnly}
          value={state}
        />
        <div className="yep_ex-absolute yep_ex-inset-y-0 yep_ex-right-0 yep_ex-flex yep_ex-items-center pr-3">
          <button onClick={() => setShowApiKey((prev) => !prev)}>
            {showApiKey ? (
              <AiOutlineEye className="yep_ex-h-5 yep_ex-w-5 yep_ex-text-gray-400" />
            ) : (
              <AiOutlineEyeInvisible className="yep_ex-h-5 yep_ex-w-5 yep_ex-text-gray-400" />
            )}
          </button>
        </div>
      </div>
      <button
        className={cn(
          'yep_ex-border yep_ex-rounded-md yep_ex-p-2.5 yep_ex-h-fit yep_ex-self-end',
          copyClassName
        )}
        onMouseDown={() =>
          navigator.clipboard
            .writeText(value)
            .then(() => showMessage('API Key Copied'))
        }
      >
        <FiCopy className="yep_ex-w-5 yep_ex-h-5" />
      </button>
      <TbTrash
        className="yep_ex-w-5 yep_ex-h-5 yep_ex-cursor-pointer"
        onClick={onDelete}
      />
    </div>
  );
};
